import { Tab, TabList, TabPanel, Tabs, tabClasses } from "@mui/joy";
import { CalendarioContainer } from "../features/tareas/Calendario/components";
import { TaskList } from "../features/tareas/TaskList/TaskList";
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';

export function TareasLayout() {
    return (
        <div className="h-full w-full">
            <Tabs
                aria-label="tabs"
                defaultValue={0}
                sx={{ 
                    height: "100%",
                    maxHeight: "100%",
                    bgcolor: 'transparent',
                    "--Tab-indicatorThickness": "2px"
                }}>
                <TabList
                    sx={{
                        [`& .${tabClasses.root}[aria-selected="true"]`]: {
                            boxShadow: 'sm',
                            bgcolor: "rgba(156, 163, 175, 0.3)",
                        },
                        bgcolor: "white",
                        color: "red",
                        fontWeight: 600,
                    }}>
                    <Tab>
                        <CalendarMonthRoundedIcon sx={{ width: 20, height: 20 }} />
                    </Tab>
                    <Tab>
                        <FormatListBulletedRoundedIcon sx={{ width: 20, height: 20 }} />
                    </Tab>
                </TabList>

                <TabPanel 
                    value={0}
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: "hidden",
                        }}>
                    <CalendarioContainer />
                </TabPanel>
                <TabPanel 
                    value={1}
                        sx={{
                            flex: 1,
                            overflow: "hidden",
                            padding: 0,
                        }}>
                    <TaskList />
                </TabPanel>
            </Tabs>
        </div>
    );
}
